"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _constants = require("../utils/constants");

var _FormInput = _interopRequireDefault(require("../Forms/FormInput"));

var _FormMessage = _interopRequireDefault(require("../Forms/_FormMessage"));

var _FormValidationOverlay = _interopRequireDefault(require("../Forms/_FormValidationOverlay"));

var _InputGroup = _interopRequireDefault(require("../InputGroup/InputGroup"));

var _keycode = _interopRequireDefault(require("keycode"));

var _Menu = _interopRequireDefault(require("../Menu/Menu"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _inputGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input-group.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _inputGroup.default);

var _ref3 = /*#__PURE__*/_react.default.createElement(_Menu.default.Item, null, "No result");

var SearchInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      compact = _ref.compact,
      cssNamespace = _ref.cssNamespace,
      disabled = _ref.disabled,
      inputProps = _ref.inputProps,
      inputGroupAddonProps = _ref.inputGroupAddonProps,
      inputGroupProps = _ref.inputGroupProps,
      inShellbar = _ref.inShellbar,
      listProps = _ref.listProps,
      localizedText = _ref.localizedText,
      noSearchBtn = _ref.noSearchBtn,
      onChange = _ref.onChange,
      onEnter = _ref.onEnter,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder,
      popoverProps = _ref.popoverProps,
      readOnly = _ref.readOnly,
      searchList = _ref.searchList,
      subStringSearch = _ref.subStringSearch,
      searchBtnProps = _ref.searchBtnProps,
      validationOverlayProps = _ref.validationOverlayProps,
      validationState = _ref.validationState,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "compact", "cssNamespace", "disabled", "inputProps", "inputGroupAddonProps", "inputGroupProps", "inShellbar", "listProps", "localizedText", "noSearchBtn", "onChange", "onEnter", "onSelect", "placeholder", "popoverProps", "readOnly", "searchList", "subStringSearch", "searchBtnProps", "validationOverlayProps", "validationState"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      searchExpanded = _useState4[0],
      setSearchExpanded = _useState4[1];

  var _useState5 = (0, _react.useState)((inputProps === null || inputProps === void 0 ? void 0 : inputProps.value) || ''),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  var filterList = function filterList(list, query) {
    return subStringSearch ? (0, _filter.default)(list).call(list, function (item) {
      var _context;

      return (0, _includes.default)(_context = item.text.toLowerCase()).call(_context, query.toLowerCase());
    }) : (0, _filter.default)(list).call(list, function (item) {
      var _context2;

      return (0, _startsWith.default)(_context2 = item.text.toLowerCase()).call(_context2, query.toLowerCase());
    });
  };

  var handleKeyPress = function handleKeyPress(event) {
    if ((0, _keycode.default)(event) === 'enter') {
      onEnter(value);
    }
  };

  var handleListItemClick = function handleListItemClick(event, item) {
    setValue(item.text);
    setIsExpanded(false);
    setSearchExpanded(false);
    item === null || item === void 0 ? void 0 : item.callback();
    onSelect(event, item);
  };

  var handleChange = function handleChange(event) {
    var filteredResult;

    if (searchList) {
      filteredResult = filterList(searchList, event.target.value);
    }

    setValue(event.target.value);
    setIsExpanded(true);
    onChange(event, filteredResult);
  };

  var handleClick = function handleClick() {
    if (!readOnly) {
      setIsExpanded(!isExpanded);
    }
  };

  var handleClickOutside = function handleClickOutside() {
    setIsExpanded(false);
    setSearchExpanded(false);
  };

  var handleEsc = function handleEsc(event) {
    if (event.keyCode === 27 && isExpanded === true || event.keyCode === 27 && searchExpanded === true) {
      setIsExpanded(false);
      setSearchExpanded(false);
      setValue('');
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleEsc, false);
    return function () {
      document.removeEventListener('keydown', handleEsc, false);
    };
  });
  var inputGroupClasses = inputGroupProps && inputGroupProps.className;
  inputGroupClasses = !inShellbar ? classnames(inputGroupClasses, "".concat(cssNamespace, "-input-group--control"), (0, _defineProperty2.default)({}, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state)) : inputGroupClasses;
  var filteredResult = value && searchList ? filterList(searchList, value) : searchList;

  var _ref2 = /*#__PURE__*/_react.default.createElement("strong", null, value);

  var popoverBody = /*#__PURE__*/_react.default.createElement(_Menu.default, null, /*#__PURE__*/_react.default.createElement(_Menu.default.List, listProps, filteredResult && filteredResult.length > 0 ? (0, _map.default)(filteredResult).call(filteredResult, function (item, index) {
    return subStringSearch ? /*#__PURE__*/_react.default.createElement(_Menu.default.Item, {
      key: index,
      onClick: function onClick(e) {
        return handleListItemClick(e, item);
      }
    }, item.text) : /*#__PURE__*/_react.default.createElement(_Menu.default.Item, {
      key: index,
      onClick: function onClick(e) {
        return handleListItemClick(e, item);
      }
    }, _ref2, value && value.length ? item.text.substring(value.length) : item.text);
  }) : _ref3));

  var inputGroup = /*#__PURE__*/_react.default.createElement(_InputGroup.default, (0, _extends2.default)({}, inputGroupProps, {
    className: inputGroupClasses,
    compact: compact,
    disabled: disabled,
    readOnly: readOnly,
    validationState: validationState
  }), /*#__PURE__*/_react.default.createElement(_FormInput.default, (0, _extends2.default)({}, inputProps, {
    disabled: disabled,
    onChange: handleChange,
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    placeholder: placeholder,
    readOnly: readOnly,
    value: value
  })), !(noSearchBtn || readOnly) && /*#__PURE__*/_react.default.createElement(_InputGroup.default.Addon, (0, _extends2.default)({}, inputGroupAddonProps, {
    isButton: true
  }), /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, searchBtnProps, {
    "aria-label": localizedText.searchBtnLabel,
    disabled: disabled,
    glyph: "search",
    onClick: handleClick,
    option: "transparent"
  }))));

  var wrappedInputGroup = /*#__PURE__*/_react.default.createElement(_FormValidationOverlay.default, (0, _extends2.default)({}, validationOverlayProps, {
    control: inputGroup,
    validationState: validationState
  }));

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: className,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({}, popoverProps, {
    body: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, validationState && /*#__PURE__*/_react.default.createElement(_FormMessage.default, (0, _extends2.default)({}, validationOverlayProps === null || validationOverlayProps === void 0 ? void 0 : validationOverlayProps.formMessageProps, {
      type: validationState.state
    }), validationState.text), popoverBody),
    control: wrappedInputGroup,
    disableKeyPressHandler: true,
    disabled: readOnly,
    noArrow: true,
    onClickOutside: handleClickOutside,
    widthSizingType: "minTarget"
  })));
});

SearchInput.displayName = 'SearchInput';
process.env.NODE_ENV !== "production" ? SearchInput.propTypes = {
  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Props to be spread to the InputGroupAddon component */
  inputGroupAddonProps: _propTypes.default.object,

  /** Props to be spread to the InputGroup component */
  inputGroupProps: _propTypes.default.object,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,
  inShellbar: _propTypes.default.bool,

  /** Additional props to be spread to the `<ul>` element */
  listProps: _propTypes.default.object,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    searchBtnLabel: _propTypes.default.string
  }),

  /** Set to **true** to render without a search button */
  noSearchBtn: _propTypes.default.bool,

  /** Localized placeholder text of the input */
  placeholder: _propTypes.default.string,

  /** Additional props to be spread to the Popover component */
  popoverProps: _propTypes.default.object,

  /** Set to **true** to mark component as readonly */
  readOnly: _propTypes.default.bool,

  /** Additional props to be spread to the search `<button>` element */
  searchBtnProps: _propTypes.default.object,

  /** Collection of items to display in the dropdown list */
  searchList: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func
  })),

  /** enable substring search */
  subStringSearch: _propTypes.default.bool,

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /**
   * Callback function; triggered when a change event is fired on the underlying `<input>`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {Object[]} matches - array of objects from searchList that match the search string.
   * @returns {void}
  */
  onChange: _propTypes.default.func,

  /**
   * Callback function; triggered when the user hits the `enter` key in the text `<input>`.
   *
   * @param {string} text - current string value of input field.
   * @returns {void}
   * */
  onEnter: _propTypes.default.func,

  /**
   * Callback function; triggered when user clicks on an option.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {Object} data - selected object from searchList
   * @returns {void}
   * */
  onSelect: _propTypes.default.func
} : void 0;
SearchInput.defaultProps = {
  localizedText: {
    searchBtnLabel: 'Search'
  },
  onChange: function onChange() {},
  onEnter: function onEnter() {},
  onSelect: function onSelect() {}
};

var _default = (0, _withStyles.default)(SearchInput);

exports.default = _default;